<section class="user-security-container">
    <form [formGroup]="formGroup"
          (submit)="formGroup.valid &&
                    formGroup.dirty &&
                    submitPassword.emit(formGroup.value)"
          uiPreventAutofill>
        <mat-form-field>
            <input #currentPasswordInput
                   [placeholder]="'profile_security_current_password' | translate"
                   [readonly]="isLoading"
                   matInput
                   uiPreventAutofill
                   formControlName="current"
                   name="current"
                   class="form-control"
                   type="password"
                   required
                   data-cy="current-password" />
            <span matSuffix>
                <ui-password-toggle [element]="currentPasswordInput"
                                    [tooltipShow]="'password_toggle_show' | translate"
                                    [tooltipHide]="'password_toggle_hide' | translate"></ui-password-toggle>
            </span>
            <mat-hint *ngIf="!formGroup.get('current')!.pristine &&
                        formGroup.get('current')!.hasError('maxlength')"
                      translate
                      [translateParams]="{
                        max: formGroup.get('current')!.getError('maxlength').requiredLength
                      }"
                      class="errorMessage">
                profile_security_password_max_warning
            </mat-hint>
        </mat-form-field>
        <mat-form-field>
            <input #newPasswordInput
                   [placeholder]="'profile_security_new_password' | translate"
                   [readonly]="isLoading"
                   matInput
                   uiPreventAutofill
                   formControlName="new"
                   name="new"
                   type="password"
                   class="form-control"
                   required
                   data-cy="new-password" />
            <span matSuffix>
                <ui-password-toggle [element]="newPasswordInput"
                                    [tooltipShow]="'password_toggle_show' | translate"
                                    [tooltipHide]="'password_toggle_hide' | translate"></ui-password-toggle>
            </span>
            <mat-hint *ngIf="!formGroup.get('new')!.pristine &&
                             !formGroup.get('new')!.hasError('complexity') &&
                             formGroup.get('new')!.hasError('maxlength')"
                      translate
                      [translateParams]="{
                          max: formGroup.get('new')!.getError('maxlength').requiredLength
                      }"
                      class="errorMessage">
                profile_security_password_max_warning
            </mat-hint>
        </mat-form-field>
        <ui-password-indicator *ngIf="!formGroup.get('new')!.pristine &&
                                    formGroup.get('new')!.hasError('complexity')"
                               [state]="formGroup.get('new')!.getError('complexity')"
                               [passwordComplexity]="passwordComplexity">
        </ui-password-indicator>
        <mat-form-field>
            <input #confirmPasswordInput
                   [placeholder]="'profile_security_confirm_password' | translate"
                   [readonly]="isLoading"
                   matInput
                   uiPreventAutofill
                   formControlName="confirm"
                   name="confirm"
                   class="form-control"
                   type="password"
                   required
                   data-cy="confirm-password" />
            <span matSuffix>
                <ui-password-toggle [element]="confirmPasswordInput"
                                    [tooltipShow]="'password_toggle_show' | translate"
                                    [tooltipHide]="'password_toggle_hide' | translate"></ui-password-toggle>
            </span>
            <mat-hint *ngIf="!formGroup.get('confirm')!.pristine &&
                            formGroup.get('confirm')!.hasError('nomatch')"
                      translate
                      class="errorMessage">
                profile_security_password_mismatch_warning
            </mat-hint>
        </mat-form-field>
        <div class="tab-footer">
            <button [spinnerButtonLoading]="isLoading"
                    [disabled]="isLoading ||
                                formGroup.invalid ||
                                formGroup.pristine"
                    ui-spinner-button
                    mat-flat-button
                    type="submit"
                    color="primary"
                    data-cy="update-password">
                {{ 'modal_action_update' | translate }}
            </button>
        </div>
    </form>
</section>
